<template>
  <div class="padding-m full-width full-height flex-1 flex-column align-center space-between">
    <div class="full-width flex-column align-center">
      <img class="margin-top-m" :src="require('@/assets/generic-faliure.png')"/>
      <div class="ri-large-headline ri-alte margin-top-l">משהו לא עבד</div>
      <div class="text ri-large-body margin-top-l align-center flex-column">
        <div>מצטערים, אולי כדאי לנסות שוב</div>
        <div>או לפנות לצוות שלנו</div>
      </div>
    </div>
    <div>
      <riseup-button title="לנסות שוב" :action="tryAgain" />
      <riseup-button title="לצוות חווית לקוחות" :action="openIntercom" variant="secondary" class="margin-top-m" />
    </div>

  </div>
</template>

<script>
import Segment from '@/Segment';
import BaseUI from '@riseupil/base-ui';
import Intercom from '@/Intercom';
import router from '@/router';
import { mapActions } from 'vuex';

export default {
  name: 'PurchaseErrorPage',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    Segment.trackUserGot('PurchaseErrorPage');
    // in case we have an open modal from the flow before
    this.closeModal();
  },
  methods: {
    ...mapActions('modalRootStore', ['closeModal']),

    openIntercom() {
      Segment.trackUserInteraction('PurchaseErrorPage_Intercom_Clicked');
      Intercom.showNewMessage('נתקלתי בבעיה בזמן רכישת שובר');
    },
    async tryAgain() {
      Segment.trackUserInteraction('PurchaseErrorPage_TryAgain_Clicked');
      await router.push({ name: 'SuperDiscountV2' });
    },
  },
};
</script>

<style scoped lang="scss">

.text {
  text-align: center;
}

img {
  max-width: 200px;
  &.large {
    max-width: 280px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}

</style>
